import React from 'react'
import { Box, Container, Heading, useColorMode, Flex } from '@chakra-ui/react'
import Spline from '@splinetool/react-spline';
import '../css/Main.css'

export default function Main() {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'

  return (
    <Box id='home' pb={10}>
        <div className='model-container'>
          <iframe className='model' src='https://my.spline.design/miniroommusiccopy-470cedff09a16cb2ec4c3552d05c3a3f/' frameBorder='0'></iframe>
          <iframe className='model-responsive' src='https://my.spline.design/miniroommusiccopycopy-e74fb973629d30d5d16ba7ff91544bc3/' frameBorder='0'></iframe>
        </div>  
        <Container maxW='container.lg' pt={10}>
          <Box borderRadius='lg' bg={ isDark ? '#c79292' : 'pink'}  p={3} align='center' mb={6} >
            Hello, I&apos;m a front-end developer based in Argentina!
          </Box>
          <Box display={{ md: 'flex'}}>
            <Box flexGrow={1}>
              <Heading as='h2' variant='page-title'>
                Macarena S.
              </Heading>
              <span><strong>(Developer / UX Designer in progress)</strong></span>
            </Box>
          </Box>
        </Container>  
    </Box>
  )
}
